import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IActivityService = ( createDecorator('activityService'));
export { IActivityService };
